export class PassSectionFieldAliases {
  static PASS_KIND = 'pass_kind'
  static ADDITIONAL_PURPOSE = 'additional_purpose'
  static TIME_TO = 'time_to'
  static TIME_OF = 'time_of'
  static TIME_INTERVAL = 'time_interval'
  static PERIOD_TO = 'period_to'
  static PERIOD_OF = 'period_of'
  static TIME_TYPE = 'time_type'
  static TERMINAL_SUBDIVISION = 'terminal_subdivision'
  static AGENT_ORGANIZATION = 'agent_organization'
  static TERMINAL_SECTOR = 'terminal_sector'
  static APPLICATION_PURPOSE = 'application_purpose'
  static TERMINAL_ID = 'terminal_id'
  static VISITORS_CATEGORY = 'visitors_category'
  static PAYMENT_TYPE = 'payment_type'
  static BIRTHDAY = 'birthday'
  static PLACEBIRTH = 'placebirth'
  static NATIONALITY = 'nationality_id'
  static IDENTIFICATION_DOCUMENT = 'identification_id'
  static IDENTIFICATION_NUMBER = 'identification_number'
  static IDENTIFICATION_DATE_OF = 'identification_date_of'
  static IDENTIFICATION_DATE_TO = 'identification_date_to'
  static IDENTIFICATION_CODE = 'identification_code'
  static IDENTIFICATION_PLACE = 'identification_place'
  static ADDRESS = 'address'
  static PHONE = 'phone'
  static ACTUAL_ADDRESS = 'actual_address'
  static ORGANIZATION_NAME = 'organization_name'
  static ORGANIZATION_POSITION = 'status'
  static ORGANIZATION_EMAIL = 'email'
}
